/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * One source of a document, an interview, a document or an imported document, kept in the server's order.
 */
class DocumentSourceRefView {
	readonly kind: 'interview' | 'document' | 'imported_document';
	readonly id: number;

	constructor(kind: 'interview' | 'document' | 'imported_document', id: number) {
		this.kind = kind;
		this.id = id;

		Object.freeze(this);
	}
}

export default DocumentSourceRefView;
